import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as homeActions from '../home/redux/actions';

import { KuposModal, KuposModalWithButtons, KuposSuccessFailure } from '../common';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';

import ApiUrls from '../../services/apiUrls';
import CancellationPolicyBlock from './CancellationPolicyBlock';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import FailedCancellation from './FailedCancellation';
import KuposHelmet from '../common/KuposHelmet';
import PassengerDetailsBlock from './PassengerDetailsBlock';
import PropTypes from 'prop-types';
import RefundDetailsBlock from './RefundDetailsBlock';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';

export class DefaultPage extends Component {
  static propTypes = {
    cancellation: PropTypes.object.isRequired,
    common: PropTypes.object,
    home: PropTypes.object,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.key = CommonService.getParameterByName('key');
    this.state = {
      selectedSeats: {},
      selectedPayment: null,
      showConfirmModal: false,
      showButton2: false,
      buttonText2: null,
      buttonText1: null,
      pbCashSelected: false,
      bankSelected: false,
      creditCardSelected: false,
      paypalSelected: false,
      couponSelected: false,
      cancelSuccess: false,
      renderCancelSuccess: false,
      allSelected: false,
      loading: false,
    };
    this.refundBlock = React.createRef();
    // this.ticketInfo = sessionStorage.getItem('ticketInfo');
    // if (this.props.home && this.props.home.metaData) {
    //   this.metaData = this.props.home.metaData;
    //   if (this.props.common.ticketDetails) {
    //     this.ticketDetails = this.props.common.ticketDetails;
    //   }
    // } else if (this.ticketInfo) {
    //   this.ticketInfo = JSON.parse(this.ticketInfo);
    //   this.ticketDetails = this.ticketInfo.ticketDetails;
    //   this.metaData = this.ticketInfo.metaData;
    // }
    this.loadTicketDetails();
    this.html = document.querySelector('html');
    this.html.style.scrollBehavior = 'initial';
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  }

  loadTicketDetails = () => {
    try {
      var decryptedData = window.atob(this.key);
      if (this.key) {
        // this.props.actions.apiCall({
        //   url: ApiUrls.ticketDetailsWithPath(decryptedData),
        //   callback: res => this.loadTicketDetailsResponse(res),
        //   type: 'home',
        // });
        let pathObj = CommonService.queryToObject(decryptedData);

        CommonService.loadEncTicketDetails(pathObj, this.props.actions.apiCall, res => {
          this.loadTicketDetailsResponse(res);
        });
      }
    } catch (e) {
      console.log('error', e);
      window.location.replace(window.location.origin);
      this.props.actions.setTicketDetails('no data');
    }
  };

  loadTicketDetailsResponse = res => {
    if (res && res.success && res.body && res.body.pnr_number) {
      // this.ticketDetails = res.body;
      this.setState({
        showDetails: true,
      });
      this.props.actions.setTicketDetails(res.body);
    }

    if (!res.success && res.body) {
      this.props.actions.setTicketDetails('no data');
      this.setState({
        cancelTicketModal: true,
        cancelTicketTitle: 'Anulación de pasaje',
        cancelTicketBodyody: res.body.message,
        showDetails: false,
      });
    }
  };
  componentDidMount() {
    this.html.style.scrollBehavior = 'initial';
    setTimeout(() => {
      this.html.style.scrollBehavior = 'smooth';
    }, 300);
    if (!this.props.common.ticketDetails && !this.ticketInfo) {
      // this.props.history.push('/');
    } else {
      if (this.props.home && this.props.home.metaData) {
        this.metaData = this.props.home.metaData;
        if (this.props.common.ticketDetails) {
          this.ticketDetails = this.props.common.ticketDetails;
        }
      } else if (this.ticketInfo) {
        this.ticketDetails = this.ticketInfo.ticketDetails;
        this.metaData = this.ticketInfo.metaData;
      }
      for (let k in this.ticketDetails.seat_Details.seat_details) {
        this.state.selectedSeats[k] = false;
      }
      if (
        this.ticketDetails.seat_Details.seat_details &&
        Object.keys(this.ticketDetails.seat_Details.seat_details).length == 1
      ) {
        for (let k in this.ticketDetails.seat_Details.seat_details) {
          this.state.selectedSeats[k] = true;
        }
      }
    }
  }

  componentDidUpdate() {
    if (this.props.common.ticketDetails) {
      let ticketInfo = {
        metaData: this.props.home.metaData,
        ticketDetails: this.props.common.ticketDetails,
      };
      this.ticketDetails = this.props.common.ticketDetails;
      sessionStorage.setItem('ticketInfo', JSON.stringify(ticketInfo));
    }
  }

  onSubmit = () => {
    // this.setState({ loading: true });
    let errorCount = 0;
    let selectedSeat = 0;
    let inps = document.querySelector('.bank-deposit-subsection-card');
    this.scrollTo = inps;
    let errors = [];
    let totalAmount = 0;
    if (this.ticketDetails && this.ticketDetails.seat_Details) {
      for (let k in this.ticketDetails.seat_Details.seat_details) {
        if (this.state.selectedSeats[k]) {
          totalAmount += this.ticketDetails.seat_Details.seat_details[k].fare;
          selectedSeat++;
        }
      }
    }
    if (selectedSeat <= 0) {
      // this.refs.toast.show('Por favor, seleccione un asiento.');
      this.scrollTo = document.querySelector('.cancellation-main');
      // seats.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_SEAT'));
      this.setState({ showErrorsModal: true, errors: errors });
      return;
    }

    if (!this.state.tncChecked) {
      // this.refs.toast.show('Por favor, seleccione un asiento.');
      this.scrollTo = document.querySelector('.cancellation-main');
      // seats.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_TNC'));
      this.setState({ showErrorsModal: true, errors: errors });
      return;
    }
    if (
      !this.state.pbCashSelected &&
      !this.state.bankSelected &&
      !this.state.paypalSelected &&
      !this.state.couponSelected &&
      !this.state.creditCardSelected
    ) {
      // inps.scrollIntoView();
      errors.push(this.props.t('CANCEL_TICKET.SELECT_REFUND'));
      errorCount++;
    }
    if (errorCount > 0) {
      // this.refs.toast.show('POR FAVOR ELIJA UN MÉTODO DE REEMBOLSO');
      this.setState({ showErrorsModal: true, errors: errors, scrollTo: inps.scrollIntoView });
      return;
    }

    if (this.state.creditCardSelected) {
      if (!this.refundBlock.current.isValidCreditCard()) {
        inps.scrollIntoView();
        return;
      }
    } else if (this.state.bankSelected) {
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:2,path:this.makePath(2)})
      if (!this.refundBlock.current.isValid()) {
        inps.scrollIntoView();
        return;
      }
    } else if (this.state.pbCashSelected || this.state.couponSelected) {
      // this.cancelPBCashConfirm()
    } else if (this.state.paypalSelected) {
      if (!this.refundBlock.current.isValidPaypal()) {
        inps.scrollIntoView();
        return;
      }
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:3,path:this.makePath(3)})
    }
    this.setState({
      showModal: true,
      modalTitle: this.props.t('CANCEL_TICKET.CANCEL_TICKET_WARNING'),
      buttonText1: this.props.t('CANCEL_TICKET.YES_CONFIRM'),
      showButton2: true,
      buttonText2: this.props.t('PROFILE.YES_GO_BACK'),
      onButtonClick1: this.onConfirm,
      totalAmount: totalAmount,
    });

    // this.onConfirm();
  };

  onErrorModalHide = () => {
    this.setState({ showErrorsModal: false, errors: null });
    setTimeout(() => {
      this.scrollTo.scrollIntoView();
    }, 250);
  };

  onConfirm = () => {




    if (this.state.bankSelected) {
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:2,path:this.makePath(2)})
      this.refundBlock.current.cancelWithCashRefund(2, this.makePath(2));
    } else if (this.state.pbCashSelected || this.state.couponSelected) {
      this.cancelPBCashConfirm();
    } else if (this.state.paypalSelected) {
      this.refundBlock.current.cancelWithCashRefund(3, this.makePath(3));
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:3,path:this.makePath(3)})
    } else if (this.state.creditCardSelected) {
      this.refundBlock.current.cancelWithCashRefund(7, this.makePath(7));
      // CommonService.goToScreen(this.props.componentId,REFUND_FORM_SCREEN,'Anular pasaje',{type:3,path:this.makePath(3)})
    }
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      modalTitle: '',
      modalBody: '',
      onButtonClick1: null,
      showButton2: false,
      buttonText2: null,
      modalIcon: null,
      modalChild: null,
      showCloseIcon: false,
    });
  };

  cancelTicketApiCall = (data, path) => {
    let pathObj = CommonService.queryToObject(path);
    let paramData = { ...data, ...pathObj };
    let dataEnc = CommonService.createJwtFullAndEncrypt(paramData, '@kup' + 'os@');
    console.log({ paramData });
    this.props.actions
      .cancelTicket({
        url: ApiUrls.cancelTicketV3(path),
        data: {
          token: dataEnc,
        },
      })
      .then(res => {
        console.log({ res });
        if (res && res.data && res.data.token) {
          let data = CommonService.decryptAndParse(res.data.token, '@kup' + 'os@');
          console.log({ data });
          res = data;
        }
        this.onResponse({ data: res });
      });
  };

  cancelPBCashConfirm = () => {
    let type;
    if (this.state.pbCashSelected) {
      type = 16;
    } else {
      type = 1;
    }
    let path = this.makePath(type);
    console.log('path is---', path);
    this.cancelTicketApiCall({}, path);
    // this.props.actions.cancelTicket({ url: ApiUrls.cancelTicket(path) }).then(res => {
    //   this.onResponse(res);
    // });
  };

  onResponse = result => {
    this.setState({ loading: false });
    console.log(result);
    this.loadTicketDetails();
    window.scrollTo(0, 0);
    if (result.data && result.data.error) {
      // this.refs.toast.show(result.data.error);
      this.setState({
        cancelSuccess: false,
        renderCancelSuccess: true,
      });
      this.closeModal();
    } else if (result.data && !result.data.success && result.data.body) {
      this.setState({
        cancelSuccess: false,
        renderCancelSuccess: true,
        cancelInfo: result.data.body.message,
      });
      this.closeModal();
    } else if (result.data && result.data.success && result.data.body) {
      this.setState({
        cancelSuccess: true,
        renderCancelSuccess: true,
      });
      this.closeModal();
      if (this.state.pbCashSelected) {
        // this.setState({
        //   showModal: false,
        //   modalTitle: '',
        //   modalBody: '',
        //   buttonText1: '',
        //   modalChild: null,
        //   onButtonClick1: null,
        //   showButton2: false,
        //   buttonText2: null,
        //   modalIcon: null,
        //   couponSelected: false,
        // });
        //   Navigation.push(this.props.componentId, {
        //     component: {
        //         name: CANCEL_SUCCESS_SCREEN,
        //         passProps: {wallet:result.data.body.cancel_ticket.wallet,screenType:1},
        //         options: {
        //             topBar: {
        //                 title: {
        //                     text: 'Anular Pasaje',
        //                     fontFamily: Platform.OS === 'android' ? 'Carnas Regular' : 'Carnas-Regular',
        //                     alignment: 'center'
        //                 },
        //                 rightButtons:  {
        //                   id: 'rightHomeButton',
        //                   icon: require('../../assets/icons/home-icon.png')
        //                 },
        //                 leftButtons:[{}]
        //             },
        //         }
        //     }
        // });
      } else {
      }
      let selectedSeats = {};
      for (let k in this.ticketDetails.seat_Details.seat_details) {
        selectedSeats[k] = false;
      }
      this.setState({
        selectedSeats: selectedSeats,
      });
      let path = 'is_mobile_app=true';
      // this.props.getTicketDetails({callback:(result) => {},pnrNumber:this.ticketDetails.pnr_number,path:path})
    }
  };

  makePath = type => {
    const ticketDetails = this.ticketDetails;
    const isChangeTicket = localStorage.getItem('isChangeTicket') == 'true' ? true : false;
    let path = 'pnr_number=' + ticketDetails.pnr_number;
    path += '&contact_info=' + ticketDetails.seat_Details.contact_details.email;
    path +=
      '&travel_date=' +
      DateService.changeDateFormat(ticketDetails.travel_date, 'dd/mm/yyyy', 'yyyy-mm-dd');
    path += '&seat_numbers=' + this.getSelectedSeats();
    path += '&refund_type=' + type;
    path += '&is_kupos=true';

    if (isChangeTicket) {
      path += '&is_change_ticket=true';
    }
    return path;
  };

  getSelectedSeats() {
    let selectedSeats = '';
    for (let k in this.ticketDetails.seat_Details.seat_details) {
      if (
        this.state.selectedSeats[k] &&
        this.ticketDetails.seat_Details.seat_details[k].cancel_status === 0
      ) {
        selectedSeats += k + ',';
      }
    }
    return selectedSeats;
  }

  onSeatChecked = seatNo => {
    const checkCopy = { ...this.state.selectedSeats };

    let isPetSeat = false;

    if (this.props.common.ticketDetails.pet_seat_info) {
      for (let pair of this.props.common.ticketDetails.pet_seat_info) {
        for (let seat of pair) {
          if (seat == seatNo) {
            isPetSeat = true;
          }
        }
        if (isPetSeat) {
          if (checkCopy[pair[0]]) {
            checkCopy[pair[0]] = false;
            checkCopy[pair[1]] = false;
          } else {
            checkCopy[pair[0]] = true;
            checkCopy[pair[1]] = true;
          }
          break;
        }
      }
    }

    if (!isPetSeat) {
      if (checkCopy[seatNo]) checkCopy[seatNo] = false;
      else checkCopy[seatNo] = true;
    }

    let allSelected = true;
    for (let key in checkCopy) {
      if (!checkCopy[key]) {
        allSelected = false;
        break;
      }
    }
    this.setState({ selectedSeats: checkCopy, allSelected: allSelected });
  };

  // onSeatChecked = seatNo => {
  //   const checkCopy = { ...this.state.selectedSeats };
  //   if (checkCopy[seatNo]) checkCopy[seatNo] = false;
  //   else checkCopy[seatNo] = true;

  //   let allSelected = true;
  //   for (let key in checkCopy) {
  //     if (!checkCopy[key]) {
  //       allSelected = false;
  //       break;
  //     }
  //   }
  //   this.setState({ selectedSeats: checkCopy, allSelected: allSelected });
  // };

  selectAll = () => {
    const checkCopy = { ...this.state.selectedSeats };
    for (let key in checkCopy) {
      checkCopy[key] = !this.state.allSelected;
    }
    this.setState({ selectedSeats: checkCopy, allSelected: !this.state.allSelected });
  };

  showLoginModal = () => { };

  renderCancelSuccesFailureScreen = (operator, isChangeTicket) => {
    if (this.state.cancelSuccess) {
      return (
        <KuposSuccessFailure
          success={true}
          subtitle={
            isChangeTicket
              ? this.props.t('CANCEL_TICKET.CHANGE_TICKET_PROCESSED')
              : this.props.t('CANCEL_TICKET.CANCELLATION_PROCESSED')
          }
          infoText={this.props.t('CANCEL_TICKET.SENT_EMAIL')}
          t={this.props.t}
          operator={operator}
          icon={getIcons('success', operator)}
        />
      );
    } else {
      return (
        <KuposSuccessFailure
          success={false}
          subtitle={this.props.t('CANCEL_TICKET.CANCELLATION_NOT_PROCESSED')}
          infoText={this.props.t('CANCEL_TICKET.SOMETHING_WENT_WRONG')}
          t={this.props.t}
          operator={operator}
          icon={getIcons('failure', operator)}
        >
          <FailedCancellation t={this.props.t} />
        </KuposSuccessFailure>
      );
    }
  };

  closeCancelModal = () => {
    window.location.replace(window.location.origin);
  };

  render() {
    const { t } = this.props;
    const isChangeTicket = localStorage.getItem('isChangeTicket') == 'true' ? true : false;
    const operator = CommonService.getLocal('op') || this.props.home.operator;

    return (
      <div className="cancellation-default-page">
        <KuposHelmet />
        {!this.state.renderCancelSuccess ? (
          <div className="content-container cancellation-main">
            <div className="cancel-screen-title font20">
              {isChangeTicket ? 'Cambia' : t('CANCEL_TICKET.TICKET_CANELLATION.NORMAL')}{' '}
              <span className="bold-text">
                {' '}
                {isChangeTicket ? 'tu pasaje' : t('CANCEL_TICKET.TICKET_CANELLATION.BOLD')}
              </span>
            </div>

            {this.props.common.ticketDetails &&
              this.state.showDetails &&
              this.props.common.ticketDetails.seat_Details ? (
              <PassengerDetailsBlock
                ticketDetails={this.props.common.ticketDetails}
                selectedSeats={this.state.selectedSeats}
                onSeatCheck={this.onSeatChecked}
                selectAll={this.selectAll}
                allSelected={this.state.allSelected}
                tncChecked={this.state.tncChecked}
                onTncChange={() => this.setState({ tncChecked: !this.state.tncChecked })}
                t={t}
                operator={operator}
                history={this.props.history}
              />
            ) : (
              <div style={{ height: '60vh' }}></div>
            )}

            {this.props.common.ticketDetails &&
              this.state.showDetails &&
              this.props.home.metaData ? (
              <div className="kupos-card bank-deposit-subsection-card">
                <RefundDetailsBlock
                  operator={operator}
                  ref={this.refundBlock}
                  onPgChange={state => this.setState({ ...state })}
                  paymentOptions={{
                    pbCashSelected: this.state.pbCashSelected,
                    bankSelected: this.state.bankSelected,
                    creditCardSelected: this.state.creditCardSelected,
                    paypalSelected: this.state.paypalSelected,
                    couponSelected: this.state.couponSelected,
                  }}
                  metaData={this.props.home.metaData}
                  ticketDetails={this.props.common.ticketDetails}
                  loginData={this.props.common.loginData}
                  showLoginModal={this.showLoginModal}
                  onResponse={this.onResponse}
                  cancelTicket={this.props.actions.cancelTicket}
                  t={t}
                  openCloseLoginModal={this.props.actions.openCloseLoginModal}
                  decryptedData={window.atob(this.key)}
                />
                <CancellationPolicyBlock
                  paymentOptions={{
                    pbCashSelected: this.state.pbCashSelected,
                    bankSelected: this.state.bankSelected,
                    creditCardSelected: this.state.creditCardSelected,
                    paypalSelected: this.state.paypalSelected,
                    couponSelected: this.state.couponSelected,
                  }}
                  t={t}
                  type="bus"
                  operator={operator}

                />

                <div className="bank-deposit-input-box font12">
                  <button
                    style={{
                      backgroundColor:
                        operator && operator.color_codes && operator.color_codes.button_color
                          ? operator.color_codes.button_color
                          : '',
                    }}
                    className="kupos-button"
                    onClick={this.onSubmit}
                  >
                    {this.state.loading ? (
                      <div className="loader-cricle"></div>
                    ) : (
                      <span>
                        {' '}
                        {isChangeTicket
                          ? 'Cambia tu pasaje'
                          : t('CANCEL_TICKET.PROCEED_WITH_CANCELLATION')}
                      </span>
                    )}
                  </button>
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          this.renderCancelSuccesFailureScreen(operator, isChangeTicket)
        )}
        <KuposModalWithButtons
          size="md"
          showModal={this.state.showModal}
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          type="alert"
          showButton1={true}
          buttonText1={this.state.buttonText1}
          onButtonClick1={this.state.onButtonClick1 ? this.state.onButtonClick1 : this.closeModal}
          showButton2={this.state.showButton2}
          buttonText2={this.state.buttonText2}
          onButtonClick2={this.state.onButtonClick2 ? this.state.onButtonClick2 : this.closeModal}
          icon={getIcons('failure', operator)}
          // icon={'/static/images/warning.png'}
          buttonTextStyle={{ fontSize: 15 }}
          // showCloseIcon={this.state.showCloseIcon}
          // closeIconPress={this.closeModal}
          onHide={this.closeModal}
          hideAllContent={this.props.cancellation.cancelTicketPending}
          operator={operator}
        >
          {this.props.cancellation.cancelTicketPending ? (
            <div className="cancel-loader">
              <span>{this.props.t('CANCEL_TICKET.LOADING')}</span>
            </div>
          ) : (
            <div className="cancel-confirm-modal-data font11 light-text">
              {/* <div className="flex-row">
                <span>{this.props.t('CANCEL_TICKET.TOTAL_AMOUNT')}</span>
                <span>CLP {CommonService.currency(this.state.totalAmount).split(',')[0]}</span>
              </div> */}
              {/* <div className="flex-row">
                <span>
                  {this.props.t('CANCEL_TICKET.CANCELLATION_FEE_SHORT')} (
                  <span className="bold-text">15%</span>)
                </span>
                <span>
                  CLP{' '}
                  {
                    CommonService.currency(
                      CommonService.percentage(this.state.totalAmount, 15),
                    ).split(',')[0]
                  }
                </span>
              </div> */}
              {/* {!this.state.pbCashSelected ? (
                <div className="flex-row">
                  <span>Cargo administrativo</span>
                  <span>CLP $600</span>
                </div>
              ) : null} */}
              {/* <hr /> */}
              {/* <div className="flex-row bold-text">
                <span>{this.props.t('CANCEL_TICKET.REFUND_TOTAL_AMOUNT')}</span>
                {!this.state.pbCashSelected ? (
                  <span>
                    CLP{' '}
                    {
                      CommonService.currency(
                        this.state.totalAmount -
                          CommonService.percentage(this.state.totalAmount, 15) -
                          600,
                      ).split(',')[0]
                    }
                  </span>
                ) : (
                  <span>
                    CLP{' '}
                    {
                      CommonService.currency(
                        this.state.totalAmount -
                          CommonService.percentage(this.state.totalAmount, 15),
                      ).split(',')[0]
                    }
                  </span>
                )}
              </div> */}

              <div className="text-center">
                {isChangeTicket
                  ? this.props.t('CANCEL_TICKET.CHANGE_MODAL_MSG1')
                  : this.props.t('CANCEL_TICKET.CANCEL_MODAL_MSG1')}
              </div>

              <div className="text-center" style={{ marginTop: 10 }}>
                {isChangeTicket
                  ? this.props.t('CANCEL_TICKET.CHANGE_MODAL_MSG2')
                  : this.props.t('CANCEL_TICKET.CANCEL_MODAL_MSG2')}
              </div>
            </div>
          )}
        </KuposModalWithButtons>
        <KuposModalWithButtons
          size="sm"
          showButton1={true}
          showModal={this.state.showErrorsModal}
          // buttonWidth="150px"
          onHide={this.onErrorModalHide}
          operator={operator}
        >
          {this.state.errors
            ? this.state.errors.map((val, key) => <div className="font11 center-text">{val}</div>)
            : null}
        </KuposModalWithButtons>

        <KuposModalWithButtons
          size="md"
          showModal={this.state.cancelTicketModal}
          title={this.state.cancelTicketTitle}
          bodyText={this.state.cancelTicketBodyody}
          type="alert"
          showButton1={true}
          buttonText1={this.state.buttonText1}
          onButtonClick1={
            this.state.onButtonClick1 ? this.state.onButtonClick1 : this.closeCancelModal
          }
          // icon={'/static/images/warning.png'}
          icon={getIcons('failure', operator)}
          buttonTextStyle={{
            fontSize: 15,
          }}
          showButton1Style={{
            backgroundColor:
              operator && operator.color_codes && operator.color_codes.button_color
                ? operator.color_codes.button_color
                : '',
          }}
          // showCloseIcon={this.state.showCloseIcon}
          // closeIconPress={this.closeModal}
          onHide={this.closeCancelModal}
          // hideAllContent={this.props.cancellation.cancelTicketPending}
          operator={operator}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    cancellation: state.cancellation,
    common: state.common,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions, ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/cancellation/DefaultPage.js